
import { client } from '../../../../../common-utils/libraries/axios/axios';
import posTerminalFields from '../../fields/posTerminalFields';
import { POS_TERMINALS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';


/**
 *
 * @param root0
 * @param root0.items
 * @param root0.totalResults
 */
function mapResponseData(items) {
    const data = {};

    const mappedItems = items.map(item => ({
        [posTerminalFields.CONNECTION_POINTS.UUID.key]: item[posTerminalFields.CONNECTION_POINTS.UUID.key],
        [posTerminalFields.CONNECTION_POINTS.IP_ADDRESS.key]: item[posTerminalFields.CONNECTION_POINTS.IP_ADDRESS.key],
        [posTerminalFields.CONNECTION_POINTS.PORT.key]: item[posTerminalFields.CONNECTION_POINTS.PORT.key],
        [posTerminalFields.CONNECTION_POINTS.INSTANCE_TAG.key]: item[posTerminalFields.CONNECTION_POINTS.INSTANCE_TAG.key]
    }));

    data[posTerminalFields.CONNECTION_POINTS.key] = mappedItems;
    return data;
}

const queryGetConnectionPoints = (subscriptionId) => {
    return {
        queryKey: [POS_TERMINALS.FETCH_CONNECTION_POINTS.queryKey, subscriptionId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(POS_TERMINALS.FETCH_CONNECTION_POINTS.url, { subscriptionId: subscriptionId }));
            return mapResponseData(response.data);
        }
    };
};


export default queryGetConnectionPoints;